import { HeaderTag } from './HeaderTag';

/**
 * Shown in place of the difficulty band while a player is inside the new-player window — the
 * queens already on the board are the thing that needs explaining, and a beginner has no use for
 * a predicted solve time yet.
 *
 * The panel says all three things a player will otherwise wonder about: which marks are not
 * theirs, that the help is running out on a schedule (so the next board being harder is not a
 * bug), and that the run carries a tag — better to read that here than to be surprised by it on
 * the leaderboard afterwards.
 */
export function NewPlayerTag({ count }: { count: number }) {
  const queens = count === 1 ? '1 queen' : `${count} queens`;

  return (
    <HeaderTag
      label="new player"
      tone="diff-new"
      ariaLabel={`New player: ${queens} already placed for you. Tap for detail.`}
    >
      <span className="diff-pop-time">{queens} placed</span>
      <span className="diff-pop-note">
        Your first three puzzles start with some queens filled in — 3, then 2, then 1 — to get you
        going. They can't be moved, and after that you're on your own.
      </span>
      <span className="diff-pop-needs">Solves with help are tagged “New Player”.</span>
    </HeaderTag>
  );
}
